import { Button, Drawer } from "antd";
import DocumentViewer from "components/DocumentViewer";

type PdfDrawerProps = {
  open: boolean;
  onClose: () => void;
  pdfUrl: string;
  loading?: boolean;
};

export default function PdfDrawer({ open, onClose, pdfUrl, loading }: PdfDrawerProps) {
  return (
    <Drawer
      className="modal-pdf-preview"
      width="100%"
      height="calc(100vh - 7px)"
      open={open}
      placement="bottom"
      onClose={onClose}
      title={
        <Button type="primary" shape="circle" size="large" onClick={onClose}>
          ✕
        </Button>
      }
      footer={null}
    >
      {pdfUrl && <DocumentViewer previewDocumentUrl={pdfUrl} loading={loading} />}
    </Drawer>
  );
}
